/* Sticky-sidebar buy-boxu (vzor aktin.cz). Když je buy-box vyšší než
   viewport, jede při scrollu spolu s obsahem a přilepí se spodní hranou
   (scroll dolů) / horní hranou (scroll nahoru).

   Plynulost: NEpřepisujeme `top` každý frame (to laguje za nativním
   scrollem = trhání). Místo toho přepínáme jen na PŘECHODECH:
   - plave s obsahem  → position: relative (v toku, jede nativně se stránkou)
   - přilepeno k viewportu → position: fixed (drží prohlížeč, kompozitně)
   Styly se zapisují jen když se mód/hodnota změní. */
(function () {
  const mql = window.matchMedia('(min-width: 990px)');

  function setup(inner) {
    if (inner.dataset.stickySidebar) return;
    inner.dataset.stickySidebar = 'true';
    const wrapper = inner.parentElement;

    let ticking = false;
    let needMetrics = true;
    let off = 0; // aktuální posun uvnitř wrapperu (px), drží se mezi framy
    let mode = '';
    let modeVal = null;

    // cachované metriky (počítají se jen na resize/změnu obsahu, ne na scroll)
    let remPx = 10;
    let topGap = 0;
    let bottomGap = 24;
    let ih = 0;
    let wrapH = 0;
    let fixedLeft = 0;
    let fixedWidth = 0;

    function readMetrics() {
      const rs = getComputedStyle(document.documentElement);
      remPx = parseFloat(rs.fontSize) || 10;
      const toPx = (value) => {
        const n = parseFloat(value);
        if (Number.isNaN(n)) return 0;
        return value.trim().endsWith('rem') ? n * remPx : n;
      };
      let headerHeight = toPx(rs.getPropertyValue('--header-height'));
      if (!headerHeight) {
        const header = document.querySelector('.section-header');
        if (header) headerHeight = header.getBoundingClientRect().height;
      }
      topGap = headerHeight - toPx(rs.getPropertyValue('--header-topbar-height')) + 2.4 * remPx;
      bottomGap = 2.4 * remPx;

      ih = inner.offsetHeight;
      const minH = ih + 'px';
      if (wrapper.style.minHeight !== minH) wrapper.style.minHeight = minH;
      wrapH = wrapper.offsetHeight;

      const ws = getComputedStyle(wrapper);
      const padL = parseFloat(ws.paddingLeft) || 0;
      const padR = parseFloat(ws.paddingRight) || 0;
      const wr = wrapper.getBoundingClientRect();
      fixedLeft = wr.left + padL;
      fixedWidth = wr.width - padL - padR;
    }

    function reset() {
      inner.style.position = '';
      inner.style.top = '';
      inner.style.bottom = '';
      inner.style.left = '';
      inner.style.width = '';
      wrapper.style.minHeight = '';
      mode = '';
      modeVal = null;
      off = 0;
    }

    function apply(newMode, val) {
      if (newMode === mode && val === modeVal) return; // beze změny → žádný zápis
      mode = newMode;
      modeVal = val;
      if (newMode === 'fixed-top' || newMode === 'fixed-bottom') {
        inner.style.position = 'fixed';
        inner.style.left = fixedLeft + 'px';
        inner.style.width = fixedWidth + 'px';
        if (newMode === 'fixed-top') {
          inner.style.top = topGap + 'px';
          inner.style.bottom = 'auto';
        } else {
          inner.style.top = 'auto';
          inner.style.bottom = bottomGap + 'px';
        }
      } else {
        inner.style.position = 'relative';
        inner.style.top = val + 'px';
        inner.style.bottom = 'auto';
        inner.style.left = '';
        inner.style.width = '';
      }
    }

    function update() {
      if (!mql.matches) {
        if (mode) reset();
        return;
      }
      const vh = window.innerHeight;
      const wrapTop = wrapper.getBoundingClientRect().top;
      const maxOff = Math.max(0, wrapH - ih);

      if (ih + topGap + bottomGap <= vh) {
        // buy-box se vejde → klasické top-sticky
        let want = topGap - wrapTop;
        if (want < 0) {
          off = 0;
          apply('relative', 0);
        } else if (want > maxOff) {
          off = maxOff;
          apply('relative', maxOff);
        } else {
          off = want;
          apply('fixed-top', null);
        }
        return;
      }

      // vyšší než viewport → plave mezi spodní a horní kotvou
      const offTop = topGap - wrapTop;
      const offBottom = vh - bottomGap - ih - wrapTop;
      let want;
      let kind;
      if (off <= offBottom) {
        want = offBottom;
        kind = 'fixed-bottom';
      } else if (off >= offTop) {
        want = offTop;
        kind = 'fixed-top';
      } else {
        want = off;
        kind = 'relative';
      }
      if (want < 0) {
        want = 0;
        kind = 'relative';
      } else if (want > maxOff) {
        want = maxOff;
        kind = 'relative';
      }
      off = want;
      if (kind === 'relative') apply('relative', want);
      else apply(kind, null);
    }

    function frame() {
      ticking = false;
      if (needMetrics) {
        needMetrics = false;
        readMetrics();
      }
      update();
    }

    function schedule(withMetrics) {
      if (withMetrics) needMetrics = true;
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(frame);
    }

    const remeasure = () => schedule(true);

    window.addEventListener('scroll', () => schedule(false), { passive: true });
    window.addEventListener('resize', remeasure);
    if (mql.addEventListener) mql.addEventListener('change', remeasure);
    new ResizeObserver(remeasure).observe(inner);
    new ResizeObserver(remeasure).observe(wrapper);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(remeasure);
    window.addEventListener('load', remeasure);
    schedule(true);
  }

  function init() {
    document.querySelectorAll('.pdp [id^="ProductInfo-"]').forEach(setup);
  }

  init();
  document.addEventListener('shopify:section:load', init);
})();
